// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__rLILO","small":"Card_small__3Gc8b","smedium":"Card_smedium__2b_14","medium":"Card_medium__2FfBP","mlarge":"Card_mlarge__1jOOt","large":"Card_large__2QheL"};